import styled from "styled-components";
import { Button } from "reactstrap";

export const Container = styled.div`
  margin: auto;
  text-align: center;
`;

export const BootstrapButton = styled(Button)`
  margin-top: 40px;
  margin-bottom: 40px;

  width: calc(100% / 2 - 5px);
  max-width: 140px;

  &:first-child {
    margin-right: 5px;
  }
`;
